module.exports = __webpack_public_path__ + "static/info-graphics-mobile-12e66de03b0582f9fc72d27218ccc508.png";